export const OnMountApp = () => {
  useOnMountApp()
  return null
}

export const useOnMountApp = () => {
  return undefined
}
